module.exports = __webpack_public_path__ + "img/schema_selle_positionnement_1a.bb80d5a5.svg";